import { LineLayer } from "mapbox-gl";

const HullStrokeLayer: LineLayer = {
  id: "hull-stroke-layer",
  type: "line",
  paint: {
    "line-color": "white",
    "line-width": 2
  }
}

export { HullStrokeLayer }
